// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vfyc","questions":"styles_questions__1caq4","footer":"styles_footer__3CTNL"};